import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { ICON_NAMES } from '@/config/config';

export const IconByAllowedPaymentMethodType = (paymentMethodType: PaymentMethodType) => {
  switch (paymentMethodType) {
    case PaymentMethodType.A2A_PAYMENT:
      return 'wallet';
    case PaymentMethodType.B2B_LOAN:
      return 'business';
    case PaymentMethodType.AUTO_LOAN:
      return ICON_NAMES.AUTO;
    case PaymentMethodType.BNPL_INSTALMENTS:
    case PaymentMethodType.BNPL_SPLIT_PAY:
    case PaymentMethodType.CARD_PAYMENT:
      return 'payment';
    case PaymentMethodType.CONSUMER_LOAN_INSTALMENTS:
    case PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY:
      return 'account_balance';
    case PaymentMethodType.CREDIT_LINE:
      return 'credit_score';
    case PaymentMethodType.SUBSCRIPTION:
      return 'credit_score';
    default:
      return 'payment';
  }
};
